type Props = () => string;

const getTimezone: Props = () => {
  const offset = (new Date().getTimezoneOffset() / 60) * -1;
  const offsetString = offset < 0 ? `${offset}` : offset > 0 ? `+${offset}` : "+0";
  return offsetString.slice(0, 4);
};

export default getTimezone;
